import React from 'react';
import ListarInsumos from '../../../components/insumos/insumos/ListarInsumos';

const InsumosPage: React.FC = () => {
  return (
    <div style={{ padding: '20px' , textAlign: 'center' , alignItems: 'center', justifyContent: 'center'}}>
      <ListarInsumos />
    </div>
  );
};

export default InsumosPage;